import { createSlice } from '@reduxjs/toolkit';
// import moment from 'moment';
import { fetchOfflineMessages } from './OfflineMessagesAPI';
// import { MessageType } from '../../app/common/constants/values';
// import { toast } from 'react-toastify';

export const initialState = {
  loading: false,
  error: null,
  totalCount: 0,
  data: [],
};

export const OfflineMessagesSlice = createSlice({
  name: 'offlineMessages',
  initialState: initialState,
  reducers: {
    setDate: (state, action) => {
      state.startDate = action.payload.start;
      state.endDate = action.payload.end;
    },
  },
  extraReducers: {
    [fetchOfflineMessages.pending]: (state) => {
      state.loading = true;
    },
    [fetchOfflineMessages.rejected]: (state, { meta, error }) => {
      state.loading = false;
      state.data = [];
      state.error = error;
    },
    [fetchOfflineMessages.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      state.error = '';
      state.data = data.offlineMessages;
      state.totalCount = data.totalCount;

      console.log('state.data = data.OfflineMessages');
      console.log(data);
    },
  },
});
export const { setDate } = OfflineMessagesSlice.actions;
export default OfflineMessagesSlice.reducer;
